module.exports = __webpack_public_path__ + "static/media/img_cal15.120b4a56.jpg";